import { createPartyRequest } from './helper';
export const getPartiesIndex = createPartyRequest({
    route: '/party/parties/index',
    method: 'get',
    source: 'data',
});
